// import React from 'react';
// import { Navigate, Outlet } from 'react-router-dom';

// function PrivateRoute() {
//   const token = localStorage.getItem('token');
//   const isAuthenticated = token !== null && token !== 'undefined';

//   return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
// }

// export default PrivateRoute;



import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

function PrivateRoute() {
  const token = localStorage.getItem('token');
  const isAuthenticated = token !== null && token !== 'undefined';
  const location = useLocation();

  // Redirect from `/admin` to `/admin/user-management` if authenticated
  if (isAuthenticated && location.pathname === '/admin') {
    return <Navigate to="/admin/user-management" replace />;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
}

export default PrivateRoute;